import Vue from 'vue'
export default {
  data () {
    return {}
  },
  watch: {},
  created () {
    Vue.prototype.$_get_ips_version_data_api = this._get_ips_version_data_api
  },
  mounted () {
    this.$nextTick(() => {
      setTimeout(() => {
        this._get_ips_version_data_api(false, true)
      }, 1000 * 1) // 最好是等1秒，让浏览器把资源先下载下来? noah modify 20240325 1000 * 0
    })
  },
  methods: {
    async _get_ips_version_data_api (showMsg = false, canUpdate = false) {
      try {
        const res = await this.$axios({
          method: 'get',
          url:
            // 兼容 IE10 ，没有origin和pathname
            window.location.href.split(window.location.hash)[0] +
            // window.location.origin +
            // window.location.pathname +
            'version' +
            `?t=${new Date().valueOf()}`
        })
        console.log('get_ips_version_data_api url::',  window.location.href.split(window.location.hash)[0] + 'version' + `?t=${new Date().valueOf()}`)
        console.log('get_ips_version_data_api res::', res)
        /* get_ips_version_data_api res:: {VUE_APP_SYSID: '', VUE_APP_VERSION: '1.0.1', VUE_APP_VERSION_TIME: '20240325114555', VUE_APP_VERSION_TIMESTAMP: '1711338355279'}*/
        const VUE_APP_VERSION_TIMESTAMP = res?.VUE_APP_VERSION_TIMESTAMP
        if (VUE_APP_VERSION_TIMESTAMP) {
          if (
            this.vuex_version_time_stamp < Number(VUE_APP_VERSION_TIMESTAMP)
          ) {
            this.$vuex('vuex_version_hasNew', true)
            if (canUpdate) {
              this.$myDialog({
                title: '发现新版本',
                message: '你可在刷新网页后，关闭并重新进入本网页，来实现网页更新。',
                // showCancelButton: true,
                confirmButtonText: '我已知晓',
                closeOnClickOverlay: true,
              })
                .then((result) => {
                  //this.$myUniSDK?.updateWeb?.();
                  console.log('发现新版本 我已知晓 then reload')
                  //location.reload(true) // noah modify 20240325
                })
                .catch((err) => {})
            }
          } else {
            showMsg &&
              this.$myToast({
                type: 'success',
                message: '当前为最新版本'
              })
          }
        }
      } catch (error) {
        console.error('get_ips_version_data_api error::', error)
      }
    }
  }
}
